<main class="middle-content">
    <div class="content-section">
        <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item active">
                <a routerLink="/subadmin-mgt">Sub Admin Management </a>
            </li>
            <li class="breadcrumb-item">Add</li>
        </ol>
        <div class="order-view mt30 max-WT-700 mrgn-0-auto">
            <form [formGroup]="addSubAdminForm">
                <div class="main-block-innner">
                    <div class="add-store-block input-style">

                        <!-- **********************Subadmin profile image ****************  -->

                        <div class="text-center mt-4 mb-5">
                            <div class="flex-block align-center">
                                <div class="profile_block" style="position: relative">
                                    <img [src]="imageUrl || 'assets/img/profile-img.jpg'" class="imagePicture"
                                        alt="banner image" (error)="onImageError($event)" />
                                    <br>
                                    <span class="camera">
                                        <i class="fa fa-camera" style="display:flex; ">
                                            <input type="file" class="cameraInput"
                                                accept="image/jpg,image/jpeg,image/png" id="file" formControlName='file'
                                                (change)="ValidateFileUpload($event)">
                                        </i> </span>

                                </div>
                                @if(addSubAdminForm.get('file').invalid && (addSubAdminForm.get('file')?.dirty ||
                                addSubAdminForm.get('file').touched)){
                                <div>
                                    @if(addSubAdminForm.get('file')?.hasError('pattern')){
                                    <span style="color: red">*Subadmin image is required.</span>
                                    }
                                </div>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> First Name :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" placeholder="First name"
                                    [formControl]="addSubAdminForm.controls['firstName']" maxlength="256"
                                    (keypress)="inputkeyPress($event)" minlength="2">
                                @if((addSubAdminForm.controls['firstName'].dirty ||
                                addSubAdminForm.controls['firstName'].touched) &&
                                addSubAdminForm.controls['firstName'].invalid){
                                <div class="error-block">
                                    @if(addSubAdminForm.controls['firstName'].hasError('required')){
                                    <span style='color:red'
                                        [ngClass]="{error:addSubAdminForm.controls['firstName'].hasError('required')}">
                                        *Please enter user first name.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['firstName'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['firstName'].hasError('pattern')}">
                                        *First name should be characters only.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['firstName'].hasError('maxlength') && !
                                    addSubAdminForm.controls['firstName'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['firstName'].hasError('maxlength') && addSubAdminForm.controls['firstName'].dirty}">
                                        *First name should be maximum 256 characters.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['firstName'].hasError('minlength') && !
                                    addSubAdminForm.controls['firstName'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['firstName'].hasError('minlength') && addSubAdminForm.controls['firstName'].dirty}">
                                        *First name should be at least 2 characters.
                                    </span>
                                    }
                                </div>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Last Name :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" placeholder="Last name"
                                    [formControl]="addSubAdminForm.controls['lastName']" maxlength="256"
                                    (keypress)="inputkeyPress($event)" minlength="2">
                            </div>
                        </div>


                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Email :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="email" class="form-control" placeholder="Email"
                                    (keypress)="passwordKeyPress($event)"
                                    [formControl]="addSubAdminForm.controls['email']" maxlength="50">
                                @if(addSubAdminForm.controls['email'].dirty &&
                                addSubAdminForm.controls['email'].invalid){
                                <div class="error-block">
                                    @if(addSubAdminForm.controls['email'].hasError('required')){
                                    <span style='color:red'
                                        [ngClass]="{error:addSubAdminForm.controls['email'].hasError('required')}">
                                        *Please enter an email.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['email'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['email'].hasError('pattern')}">
                                        *Please enter valid email.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['email'].hasError('maxlength') && !
                                    addSubAdminForm.controls['email'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['email'].hasError('maxlength') && addSubAdminForm.controls['email'].dirty}">
                                        *Please enter valid email.
                                    </span>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                        <div class="form-group row align-items-baseline mb-3">
                            <label class="col-md-4">
                                <h6>Phone Number : </h6>
                            </label>
                            <div class="col-md-3">
                                <select name="patient" style="padding: 0 40px" formControlName="phoneCode"
                                    class="custom-select form-control" id="inputGroupSelect01"
                                    aria-labelledby="dropdownMenuButton">
                                    <option value="">Dial Code</option>
                                    @for (data of countryArr; track data; let i = $index) {
                                    <option [value]="data.phone_code">
                                        {{data.phone_code}} &nbsp; {{data.name}}</option>
                                    }
                                </select>
                            </div>
                            <div class="col-md-5">
                                <input type="tel" class="form-control" placeholder="Phone Number"
                                    (keypress)="inputKeyPress($event)"
                                    [formControl]="addSubAdminForm.controls['phoneNumber']" maxlength="20">
                                @if(addSubAdminForm.controls['phoneNumber'].dirty &&
                                addSubAdminForm.controls['phoneNumber'].invalid){
                                <span class="error-block text-nowrap text-start">
                                    @if(addSubAdminForm.controls['phoneNumber'].hasError('required')){
                                    <span style='color:red'
                                        [ngClass]="{error:addSubAdminForm.controls['phoneNumber'].hasError('required')}">
                                        *Please enter a phone number.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['phoneNumber'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['phoneNumber'].hasError('pattern')}">
                                        *Please enter valid Phone number.
                                    </span>
                                    }
                                </span>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Password :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="password" class="form-control" (keypress)="passwordKeyPress($event)"
                                    [formControl]='addSubAdminForm.controls["password"]' maxlength="16"
                                    placeholder="Password">
                                @if(addSubAdminForm.controls['password'].dirty &&
                                addSubAdminForm.controls['password'].invalid){
                                <div class="error-block">
                                    @if(addSubAdminForm.controls['password'].hasError('required')){
                                    <span style='color:red'
                                        [ngClass]="{error:addSubAdminForm.controls['password'].hasError('required')}">
                                        *Please enter password.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['password'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error:addSubAdminForm.controls['password'].hasError('pattern')}">
                                        *Password must be between 8 to 16 characters and contain at least one special
                                        character , one digit.
                                    </span>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6>Confirm Password :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="password" class="form-control" (keypress)="passwordKeyPress($event)"
                                    placeholder="Retype your password"
                                    [formControl]='addSubAdminForm.controls["confirmPassword"]' maxlength="16">
                                @if(addSubAdminForm.controls['confirmPassword'].dirty){
                                <div class="error-block">
                                    @if(addSubAdminForm.controls['confirmPassword'].value !=
                                    addSubAdminForm.controls['password'].value){
                                    <span style='color:red'>
                                        *Password mismatched.
                                    </span>
                                    }
                                </div>
                                }
                            </div>
                        </div>


                        <!-- <div class="d-flex mt-5 max-WT-400 justify-content-center mb-5"> -->
                        <div class="form-group row">
                            <label class="col-md-12">
                                <h6> Permissions :</h6>
                            </label>
                        </div>
                        <!-- <div class="pl-5"> -->
                        <div class="form-group row ">
                            <div class="col-md-6">
                                <label class="checkbox-design d-block">
                                    <input type="checkbox" formControlName="dashboard"
                                        value="True"><span></span>Dashboard
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="subadminManagement"
                                        value="True"><span></span>Subadmin Management
                                </label>
                            </div>

                        </div>
                        <div class="form-group row ">
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="patientManagement"
                                        value="True"><span></span>Patient Management
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="therapistManagement"
                                        value="True"><span></span>Therapist Management
                                </label>
                            </div>

                        </div>
                        <div class="form-group row">
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="programTypeManagement"
                                        value="True"><span></span>Program Type Management
                                </label>
                            </div>

                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="programManagement"
                                        value="True"><span></span>Program Management
                                </label>
                            </div>

                        </div>

                        <div class="form-group row">
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="transactionManagement"
                                        value="True"><span></span>Transaction Management
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="assessment"
                                        value="True"><span></span>Assessments and Forms
                                </label>
                            </div>

                        </div>
                        <!-- Faq Added -->
                        <div class="form-group row">
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="staticContentManagement"
                                        value="True"><span></span>Static content Management
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="faqManagement" value="True"><span></span>Faq
                                    Management
                                </label>
                            </div>

                        </div>

                        <div class="form-group row">
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="journalManagement"
                                        value="True"><span></span>Journal Management
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="notificationManagement"
                                        value="True"><span></span>Notification Management
                                </label>
                            </div>

                        </div>

                        <div class="form-group row">
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="libraryManagement"
                                        value="True"><span></span>Library/Handout Management
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="reviewManagement"
                                        value="True"><span></span>Review and rating Management
                                </label>
                            </div>

                        </div>
                        <div class="form-group row">
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="queryManagement"
                                        value="True"><span></span>Query Management
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label class="checkbox-design d-block mb-2 mt-2">
                                    <input type="checkbox" formControlName="chatManagement"
                                        value="True"><span></span>Chat Management
                                </label>
                            </div>
                        </div>




                        <div class="text-center mt40">
                            <button class="btn btn-theme"
                                [disabled]="addSubAdminForm.invalid || (addSubAdminForm.controls['confirmPassword'].value != addSubAdminForm.controls['password'].value)"
                                (click)="addSubAdminApi()">Add</button>
                            <button class="btn btn-danger" style="margin-left: 20px;min-width: 100px;"
                                routerLink="/subadmin-mgt">Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</main>